import { ToastConfig } from './../../controllers/ToastController/types'
export const ANIMATION_DURATION = 400 as const

export const DEFAULT_CONFIGS: ToastConfig = {
  autoClose: 5000,
  theme: 'light',
  position: 'bottom-left',
  variant: 'success',
}
